// Role-based route guards.
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export function RequireTenant({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "tenant") {
    // Logged in but as landlord/admin — bounce to their home.
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}

export function RequireLandlord({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "tenant") {
    // Show a toast once, then send tenants to their portal.
    try {
      toast.error("That page is for landlords. Redirecting to your portal.");
    } catch (err) {
      // toast manager not initialised yet (e.g. during pre-mount redirect).
      if (process.env.NODE_ENV !== "production") {
        console.warn("RequireLandlord: toast failed", err);
      }
    }
    return <Navigate to="/tenant" replace />;
  }
  return children;
}
